/*eslint-disable*/
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import Markdown from "markdown-to-jsx";
import styled, { css, keyframes } from "styled-components";

import ch_im from '../../assets/images/chat_im.svg'

import { SORT_ORDERS, TABLES, dormitoryQuestionnaireSteps } from "../../constants/config";
import useDebounce from "../../hooks/useDebounde";
import usePagination from "../../hooks/usePagination";
import { putStorage, useStorageListener } from "../../hooks/useStorage";
import { convertHex } from "../../services/colors-service";
import { stringImposition, togglePush } from "../../services/common-service";
import StatusLabel, { BookingStatuses } from "./status-label";
import { Button, Checkbox, Dropdown, HoverDropdown, Frame, Row, RowWrapper } from "./styled-templates";
import Tooltip from "./tooltip";

import PaginationControl from "components/tools/pagination-control";

import { ERequestStatus } from "types/enums";
import ChatMessagesNumberSpan from "../chat/panels/ChatMessagesNumberSpan";

const Table = (props) => {
    const { t } = useTranslation();

    const {
        extra = ``,
        selectable = false,
        name,
        sortable = false,
        columns = [],
        selectionLimit = Infinity,
        withPagination = true,
        withHeader = true,
        paginationOptions = [10, 25, 50, 100, 500],
        defaultSort,
        idColumnName = `id`,
        fetchFunction = () => {
            // console.log(`> > > FETCH < < <`);
        },
        dependencies = {},
        tableStyles = ``,
        paginationStyles = ``,
        extraHeader,
        useBackendProcessing = true,
        rows: propRows = [],
        filters: propsFilters = {},
        booleanOperation = `conjunction`,
        ignoreInitFetch = false
    } = props;
    if (!name) {
        throw new Error(`[table.js] - name is not  defined`);
    }
    const tableState = useStorageListener((state) => _.get(state, `tables.${name}`) ?? {});

    const { rows = [] } = tableState;

    const { selectedRows = [] } = tableState;
    const setSelectedRows = (newValue = []) => {
        putStorage(`tables.${name}.selectedRows`, newValue.slice(0, selectionLimit));
    };
    const { filters } = tableState;
    const setFilter = (filter, newValue) => {
        putStorage(`tables.${name}.filters.${filter}`, newValue);
    };
    const sort = tableState?.sort?.[0] ?? defaultSort;
    const setSort = (field, order) => {
        putStorage(`tables.${name}.sort`, [{ field, order }]);
    };
    const filterRows = (rows = []) => {
        return rows?.filter?.((i) => {
            if (useBackendProcessing) {
                return true;
            }
            return (
                Object.keys(_.pickBy(filters, _.identity)).length === 0 ||
                Object.entries(_.pickBy(filters, _.identity))
                    ?.map?.(([key, value], index) => !value || stringImposition(_.get(i, key), value))
                    ?.reduce?.(
                    ...{
                        conjunction: [(a, b) => a && b, true],
                        disjunction: [(a, b) => a || b, false]
                    }?.[booleanOperation ?? `conjunction`]
                )
            );
        });
    };
    let sortedPropRows = propRows;
    if (!useBackendProcessing) {
        sortedPropRows = propRows.sort((a, b) => {
            const aValue = _.get(a, sort?.field);
            const bValue = _.get(b, sort?.field);
            if (sort?.order === SORT_ORDERS.ASC) {
                return aValue > bValue ? 1 : -1;
            }
            return aValue < bValue ? 1 : -1;
        });
    }
    const frontendPagination = usePagination(filterRows(useBackendProcessing ? rows : sortedPropRows), { perPage: 10 });
    const pagination = useBackendProcessing ? tableState?.pagination ?? {} : frontendPagination ?? {};
    const { currentPage = 0, perPage = paginationOptions?.[0] ?? 1, pagesCount = 1, totalCount = 1 } = pagination;
    const maxPageNumber = Math.ceil(totalCount / perPage);
    const debouncedParams = useDebounce(JSON.stringify({ filters }), 300);
    useEffect(async () => {
        if (!tableState?.sort) {
            putStorage(`tables.${name}.sort`, [defaultSort], { silent: true });
        }
        if (!tableState?.pagination) {
            putStorage(`tables.${name}.pagination`, { currentPage, perPage }, { silent: true });
        }
        if (useBackendProcessing) {
            const newData = await fetchFunction({ perPage, currentPage: currentPage + 1 });
        }
    }, [JSON.stringify({ debouncedParams, sort, name, currentPage, perPage, dependencies })]);

    useEffect(async () => {
        if (!useBackendProcessing && !ignoreInitFetch) {
            const newData = await fetchFunction();
        }
    }, []);
    useEffect(() => {
        // if (useBackendProcessing) {
        putStorage(`tables.${name}.filters`, propsFilters);
        // }
    }, [JSON.stringify(propsFilters), useBackendProcessing]);

    return (
        <TableWrapper extra={extra}>
            {extraHeader}
            <STable extra={tableStyles}>
                {withHeader && (
                    <STr
                        extra={({ theme }) =>
                            `border-bottom: 0px; padding: 16px; box-sizing: border-box; background: #F4F4F4; color: #8B8B8B; border-radius: 6px 6px 0px 0px;`
                        }
                    >
                        {selectable && <STh extra={`flex: unset; width: 40px;`}></STh>}
                        {columns.map((column, index) => {
                            return (
                                <STh key={index} extra={column?.extra ?? ``} className={"table_th"}>
                                    <Frame
                                        extra={`flex-direction: row; cursor: pointer;`}
                                        onClick={() => {
                                            setSort(
                                                column?.name,
                                                column?.name === sort?.field
                                                    ? {
                                                    [SORT_ORDERS.ASC]: SORT_ORDERS.DESC,
                                                    [SORT_ORDERS.DESC]: SORT_ORDERS.ASC
                                                }?.[sort?.order] ?? SORT_ORDERS.DESC
                                                    : SORT_ORDERS.DESC
                                            );
                                        }}
                                    >
                                        {name === "requests" && column.name === "status" ? (
                                            <Dropdown
                                                toggle={() => column.label}
                                                menu={() => {
                                                    return (
                                                        <div
                                                            className="flex flex-col w-full justify-center items-center gap-2">
                                                            <span
                                                                className="hover:opacity-50 cursor:pointer text-red"
                                                                onClick={() => setFilter(column.name, null)}
                                                            >
                                                                Снять фильтр
                                                            </span>
                                                            {Object.keys(BookingStatuses).map((i) => {
                                                                return (
                                                                    <span
                                                                        className="hover:opacity-50 cursor:pointer"
                                                                        onClick={() => setFilter(column.name, i)}
                                                                    >
                                                                        {BookingStatuses[i]}
                                                                    </span>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                }}
                                            />
                                        ) : (
                                            column.label
                                        )}
                                        {sortable && column.sortable !== false && (
                                            <Frame extra={`margin-left: 10px; cursor: pointer;`}>
                                                <SortArrow
                                                    extra={`opacity: ${
                                                        sort?.field === column.name && sort?.order === SORT_ORDERS.ASC ? 1 : 0.2
                                                    }; transform: rotate(180deg);`}
                                                />
                                                <SortArrow
                                                    extra={`opacity: ${sort?.field === column.name && sort?.order === SORT_ORDERS.DESC ? 1 : 0.2};`}
                                                />
                                            </Frame>
                                        )}
                                    </Frame>
                                </STh>
                            );
                        })}
                    </STr>
                )}
                {/* <STr>
                    {selectable && (
                        <STh extra={`flex: unset; width: 40px;`} title={`Select all`}>
                            <Checkbox
                                checked={selectedRows.length === rows.length}
                                onChange={(e) => {
                                    setSelectedRows(
                                        selectedRows.length === rows.length || selectedRows.length === selectionLimit
                                            ? []
                                            : rows.map((i) => i?.[idColumnName])
                                    );
                                }}
                            />
                        </STh>
                    )}
                    {columns.map((column, index) => {
                        return (
                            <STh key={index} extra={column?.extra ?? ``}>
                                {
                                    {
                                        input: (
                                            <Input
                                                value={filters?.[column?.name] ?? ``}
                                                onChange={(e) => {
                                                    setFilter(column?.name, e.target.value);
                                                }}
                                                extra={`width: 100%`}
                                            />
                                        ),
                                        select: (
                                            <Select
                                                value={filters?.[column?.name]}
                                                onChange={(e) => {
                                                    setFilter(column?.name, e.target.value);
                                                }}
                                                extra={`width: 100%`}
                                                options={[].map((i) => ({ label: i, value: i }))}
                                                {...column?.filter}
                                            />
                                        ),
                                    }?.[column?.filter?.type]
                                }
                            </STh>
                        );
                    })}
                </STr> */}
                {filterRows(
                    !useBackendProcessing && withPagination ? frontendPagination.visibleItems ?? [] : rows.length === 0 && propRows ? propRows : rows
                )?.length === 0 && <PlaceholderNoData>{t("k28trhy1dj")}</PlaceholderNoData>}
                {filterRows(
                    !useBackendProcessing && withPagination ? frontendPagination.visibleItems ?? [] : rows.length === 0 && propRows ? propRows : rows
                )?.map?.((row, row_index) => (
                    <STr key={row_index} extra={name === TABLES.PROCESSES_LIST && `align-items: flex-start;`}
                         className={`table_tr ${row.hideFromAll == true ? 'lightgray_tr' : ''}`}>
                        {selectable && (
                            <STd extra={`flex: unset; width: 40px;`}>
                                <Checkbox
                                    disabled={!selectedRows.includes(row?.[idColumnName]) && selectedRows.length === selectionLimit}
                                    checked={selectedRows.includes(row?.[idColumnName])}
                                    onChange={(e) => {
                                        setSelectedRows(togglePush(selectedRows, row?.[idColumnName]));
                                    }}
                                />
                            </STd>
                        )}
                        {columns.map((column, column_index) => {
                            const cellState = { row, column, value: _.get(row, column?.name) };
                            return (
                                <TableCell
                                    row_index={row_index}
                                    showIndexOnClick={column?.showIndexOnClick}
                                    column_index={column_index}
                                    key={column_index}
                                    cellState={cellState}
                                />
                            );
                        })}
                    </STr>
                ))}
            </STable>
            {withPagination && <PaginationControl pagination={frontendPagination} />}
        </TableWrapper>
    );
};

const smartStringify = (value) => {
    return !!value && !!`${value}` ? (typeof value !== `string` ? JSON.stringify(value) : value) : `-`;
};

const TableCell = ({ cellState, column_index, row_index }) => {
    const navigate = useNavigate();
    const { row, column, value, jsxTransform } = cellState;
    const transformedValue = smartStringify(column?.transform?.(cellState) ?? value ?? _.get(row, column.name));
    let showIndexOnClick = column?.showIndexOnClick == true;
    const cellContent = useMemo(
        () =>
            ({
                text: <Markdown tooltip={`${column_index}`}>{`${transformedValue}`}</Markdown>,
                icon: <Icon {...column?.cell} {...(column?.cell?.srcFunction == undefined ? {} : {src: column?.cell?.srcFunction(cellState)})} />,
                statusLabel: (
                    <HoverDropdown
                        toggle={() => (
                            <StatusLabel
                                status={column?.transform?.(cellState)}>{BookingStatuses[column?.transform?.(cellState)]}</StatusLabel>
                        )}
                        menu={() =>
                            [
                                ERequestStatus.New,
                                ERequestStatus.Approved,
                                ERequestStatus.Review,
                                ERequestStatus.Rejected,
                                ERequestStatus.DoneVisited,
                                ERequestStatus.DoneNotVisited
                            ].map((status) => (
                                <StatusLabel key={status} status={status}
                                             onClick={() => column?.cell?.onChange?.({ ...row, status })}
                                             style={{ cursor: 'pointer' }}>
                                    {BookingStatuses[status]}
                                </StatusLabel>
                            ))
                        }
                        menuProps={{ extra: `> * { gap: 5px; align-items: center; > * { cursor: pointer; &:hover { opacity: 0.7; } }; };` }}
                    />
                ),
                dormitoryComplitnessStatus: <DormitoryComplitnessStatus dormitory={row} />,
                menu: (
                    <Dropdown
                        toggle={() => <Icon src="more-vert" />}
                        menu={() => (
                            <>
                                {column?.cell?.options?.map?.((option, index) => (
                                    <Option key={index} {...option}
                                            onClick={() => option?.onClick?.({ ...cellState, navigate })} />
                                ))}
                            </>
                        )}
                    />
                ),
                button: <Button {...column?.cell} />,
                chat: <ChatBox onClick={() => {
                    column?.cell?.onClick(row);
                }}>
                    <ChatImg src={ch_im} />
                    <ChatMessagesNumberSpan
                        groupId={row.id}
                    />
                    {/*<ChatMessagesNumberSpan*/}
                    {/*    */}
                    {/*/>*/}
                    {/*{(column?.cell?.messagesNumber == undefined || column?.cell?.messagesNumber == 0) ? null :*/}
                    {/*    <span>{`${column?.cell?.messagesNumber}`}</span>*/}
                    {/*}*/}
                </ChatBox>
            }?.[column?.cell?.type ?? `text`] ?? ``),
        [JSON.stringify(cellState)]
    );
    return (
        <STd
            extra={(column?.extra ?? ``) + (column?.cell?.extra ?? ``)}
            clickable={column?.onCellClick}
            onClick={() => {
                if (showIndexOnClick == true) {
                    window.alert(`Строка №${+row_index + 1}`);
                }
                column?.onCellClick?.(cellState);
            }}
        >
            {column?.tooltip ? (
                <Tooltip
                    {...(_.isFunction(column?.tooltip) ? column?.tooltip(cellState) : column?.tooltip)}
                    children={cellContent}
                    tooltipProps={{
                        extra: `max-width: 350px; width: max-content; white-space: break-spaces;`
                    }}
                />
            ) : (
                cellContent
            )}
        </STd>
    );
};

const DormitoryComplitnessStatus = ({ dormitory }) => {
    const { progress } = dormitory;
    return (
        <Row extra="gap: 5px;">
            {_.values(progress).map((step, index) => (
                <Tooltip
                    key={index}
                    label={`Шаг "${dormitoryQuestionnaireSteps?.find?.((i) => i?.name === _.keys(progress)?.[index])?.title}" ${
                        step ? `завершен` : `не завершен`
                    }`}
                >
                    <StatusCircle status={step ? `done` : `undone`} />
                </Tooltip>
            ))}
        </Row>
    );
};

const Option = styled(Frame)`
  width: 175px;
  padding: 8px;
  flex-direction: row;
  justify-content: flex-start;
  cursor: default;
  opacity: 0.5;

  ${({ muted = false }) =>
          !muted &&
          css`
            cursor: pointer;
            opacity: 1;
          `}
  ${({ muted = false }) =>
          !muted &&
          css`
            &:hover {
              &:after {
                transform: translate(2px, 0);
              }
            }
          `}
  &:after {
    content: "${({ label = `` }) => label}";
    transition: 0.2s;
  }
`;

const StatusCircle = styled(Frame)`
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: ${({ theme, status }) => theme[{ done: `green`, undone: `red` }?.[status]]};
`;

const ChatBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

const ChatImg = styled.img`
  height: 24px;
  margin-right: 5px;
`;

const PlaceholderNoData = styled(Frame)`
  color: ${(props) => props.theme.grey};
  font-size: 16px;
  padding: 40px 0;
`;

const ProcessStatus = styled(Frame)`
  width: 158px;
  padding: 4px 0;
  box-sizing: border-box;
  border-radius: 4px;
  background: ${({ theme, status }) => convertHex(theme?.[status?.color] ?? `#fff`, 0.15)};
  color: ${({ theme, status }) => theme?.[status?.color] ?? `#fff`};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

const EventLogButton = styled.button`
  border: 0px;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 2px solid #d4d4d4;
  padding-bottom: 2px;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  background: unset;
  display: flex;
  color: ${({ theme }) => theme.text.primary};
`;

const Icon = styled(Frame)`
  width: 20px;
  height: 20px;
  background: url("${({ src }) => (src == undefined || src == '' || src == '.' ? '' : require(`../../assets/icons/${src}.svg`))}") no-repeat center center / contain;
  opacity: ${({ src }) => (src == undefined || src == '' || src == '.' ? '0' : '100')};
  cursor: pointer;
`;

const StatisticsItem = styled(Frame)`
  width: 24px;
  height: 24px;
  border: 2px solid ${({ theme, status = `failed` }) =>
          ({
            success: theme.green,
            running: theme.yellow,
            failed: theme.red,
            shutdown: theme.grey
          }?.[status ?? `failed`])};
  border-radius: 50%;

  &:after {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    content: "${({ value = 0 }) => value}";
  }
`;

const Info = styled(Frame)`
  width: 16px;
  height: 16px;
  background: url("${require(`../../assets/icons/info.svg`).default}") no-repeat center center / contain;
  margin-left: 8px;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

const SpinningArrows = styled(Frame)`
  margin-left: 8px;
  margin-bottom: 24px;
  width: 16px;
  height: 16px;
  background: url("${require(`../../assets/icons/spinning-arrows.svg`).default}") no-repeat center center / contain;
  animation: ${rotate} 3s linear infinite;
`;

const PageNumberWrapper = styled(Frame)`
  width: 34px;
  height: 34px;
  background: ${({ theme, selected = false }) => (selected ? theme.darkblue : theme.background.secondary)};
  margin-right: 16px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme, selected = false }) => (selected ? `#FFFFFF` : theme.text.primary)};
  font-weight: ${({ selected = false }) => (selected ? `bold` : `regular`)};
  cursor: pointer;
`;

const TableWrapper = styled(Frame)`
  width: 100%;
  /* height: 100%; */
    /* background: ${({ theme }) => theme.background.primary}; */
  /* border: 1px solid #dadada; */
  border-radius: 6px;
  box-sizing: border-box;
`;

const PaginationWrapper = styled(RowWrapper)`
  /* margin-top: 20px; */
  justify-content: space-between;
  padding: 20px 20px 20px 120px;
  box-sizing: border-box;
  /* border-top: 1px solid #dadada; */

  > * {
    margin-right: 10px;
  }
`;

const PaginationArrow = styled(Frame).attrs((props) => {
    return {
        ...props,
        onClick: props?.disabled ? () => {
        } : props?.onClick
    };
})`
  width: 20px;
  height: 20px;
  background: url("${require(`../../assets/icons/arrow-right.svg`).default}") no-repeat center center / contain;
  margin-bottom: -5px;
  cursor: pointer;

  ${({ disabled = false }) =>
          disabled
                  ? css`
                    cursor: default;
                    opacity: 0.2;
                  `
                  : css`
                    &:hover {
                      opacity: 0.5;
                    }
                  `}

  ${({ extra }) => extra}
`;

export const SortArrow = styled(Frame)`
  width: 15px;
  height: 15px;
  background: url("${require(`../../assets/icons/arrow-down.svg`).default}") no-repeat center center / contain;
  margin-bottom: -5px;

  ${({ extra }) => extra}
`;

const STd = styled(Frame)`
  padding: 4px;
  justify-content: flex-start;
  width: 100%;
  flex: 1;
  flex-direction: row;

  /* overflow: hidden; */
  white-space: break-spaces;

  ${({ clickable }) =>
          clickable &&
          css`
            cursor: pointer;

            &:hover {
              opacity: 0.5;
            }
          `}

  ${({ extra }) => extra}
`;

const STh = styled(Frame)`
  padding: 4px;
  justify-content: flex-start;
  width: 100%;
  flex: 1;
  flex-direction: row;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;

  ${({ extra }) => extra}
`;

const STr = styled(Frame)`
  height: max-content;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 0.5px solid ${convertHex(`#212121`, 0.05)};
  align-items: flex-start;
  white-space: nowrap;

  > * {
    word-break: break-word;
  }

  ${({ extra }) => extra}
`;

const STable = styled(Frame)`
  width: 100%;
  border-collapse: collapse;

  ${({ extra }) => extra}
`;

export default Table;
/*eslint-enable*/
